<template>
  <div class="pa-4">
    <h1 class="headline mb-4 pt-4">Reports</h1>
    <v-row>
      <v-col sm="6">
        <v-select
          v-model="reportType"
          :items="reportTypes"
          return-object
          item-text="name"
          label="Report Type"
          prepend-icon="insert_chart"
          hide-details
        ></v-select>
        <div
          class="mt-4 pt-2"
          v-if="reportType && reportType.name === 'Truck Requests PDF'"
        >
          <job-selector @jobSiteChange="jobSite = $event" :whiteBg="true" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDateFormattedMomentjs"
              label="Start Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            @input="menu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col sm="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDateFormattedMomentjs2"
              label="End Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <!-- <v-col sm="3">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              label="End Date"
              prepend-icon="event"
              readonly
              v-on="on"
              disabled
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(date)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col> -->
    </v-row>
    <v-row>
      <v-col sm="12" class="pt-0">
        <v-btn color="primary" @click="generateReport" :disabled="!reportType">
          <v-icon left>timeline</v-icon> Generate Report</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="12">
        <v-simple-table class="elevation-2">
          <thead>
            <tr>
              <th class="text-left" width="220">Date Created</th>
              <th class="text-left" width="450">Report</th>
              <th class="text-left">Report Dates</th>
              <th class="text-left">Created By</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="report in reports" :key="report.id">
              <td class="pa-4">
                <span v-if="report.createDate">{{
                  report.createDate.toDate() | moment("MMM Do YYYY [at] h:mma")
                }}</span>
              </td>
              <td>
                {{ report.reportType }}
                <div v-if="report.reportType === 'Truck Requests PDF' && report.jobSite" class="caption grey--text">
                  {{ report.jobSite.address }}
                </div>
              </td>
              <td>
                <div v-if="report.startDate && report.endDate">
                  {{ report.startDate | moment("MM/DD/YYYY") }}
                  -
                  {{ report.endDate | moment("MM/DD/YYYY") }}
                </div>
              </td>
              <td>
                <div v-if="report.createdBy">
                  {{ report.createdBy.firstName }}
                  {{ report.createdBy.lastName }}
                </div>
              </td>
              <td class="text-right">
                <v-tooltip
                  bottom
                  v-if="report.status === 'error' && report.errorMessage"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn color="error" text outlined disabled>ERROR</v-btn>
                    </div>
                  </template>
                  <span>Error: {{ report.errorMessage }}</span>
                </v-tooltip>
                <v-btn
                  v-else
                  color="primary"
                  text
                  outlined
                  :disabled="report.status === 'error'"
                  @click="downloadCsv(report.id)"
                  :loading="report.status === 'processing'"
                >
                  <span v-if="report.status === 'error'">ERROR</span>
                  <span v-else>Download report</span>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import fb from "@/main";
import moment from "moment";
import JobSelector from "../components/JobSelectorAll.vue";
import { mapState } from "vuex";
export default {
  components: {
    JobSelector,
  },
  data: () => ({
    startDate: moment()
      .startOf("month")
      .format("YYYY-MM-DD"),
    endDate: new Date().toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    reportType: null,
    jobSite: null,
    reportTypes: [
      {
        name: "Dump Reports",
        collection: "truckRequests",
      },
      {
        name: "Truck Service",
        collection: "truckService",
      },
      {
        name: "Tool Orders",
        collection: "toolOrders",
      },
      {
        name: "Truck Requests PDF",
        collection: "truckRequestsPDF",
      },
    ],
    reports: [],
    unsubscribe: null,
  }),
  async created() {
    const that = this;
    this.unsubscribe = await fb.db
      .collection("reports")
      .orderBy("createDate", "desc")
      .limit(50)
      .onSnapshot(function(querySnapshot) {
        var reports = [];
        querySnapshot.forEach(function(doc) {
          reports.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        that.reports = reports;
      });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    ...mapState(["user"]),
    computedDateFormattedMomentjs() {
      return this.startDate ? moment(this.startDate).format("MM/DD/YYYY") : "";
    },
    computedDateFormattedMomentjs2() {
      return this.endDate ? moment(this.endDate).format("MM/DD/YYYY") : "";
    },
  },
  methods: {
    async generateReport() {
      try {
        const data = {
          status: "processing",
          createDate: fb.timestamp,
          jobSite: this.jobSite || null,
          reportType: this.reportType.name,
          collection: this.reportType.collection,
          startDate: this.startDate,
          endDate: this.endDate,
          createdBy: this.user,
        };

        // Validate that start date is before end date
        const startMoment = moment(this.startDate);
        const endMoment = moment(this.endDate);

        if (startMoment.isAfter(endMoment)) {
          this.$store.dispatch("snackbar", {
            message: "Start date must be before end date",
            color: "error",
          });
          return;
        }

        // Show loading notification
        this.$store.dispatch("snackbar", {
          message: "Generating report. This may take a minute...",
          color: "info",
        });

        await fb.db.collection("reports").add(data);
      } catch (error) {
        this.$store.dispatch("snackbar", {
          message: "Error generating report",
          color: "error",
        });
      }
    },
    async downloadCsv(id) {
      try {
        // Find the report to determine the file type and status
        const report = this.reports.find((r) => r.id === id);

        if (!report || report.status === "error") {
          this.$store.dispatch("snackbar", {
            message:
              "This report has an error and cannot be downloaded. Please try generating it again.",
            color: "error",
          });
          return;
        }

        const fileExtension =
          report && report.collection === "truckRequestsPDF" ? "pdf" : "csv";

        const reportRef = fb.storage.ref(`reports/${id}.${fileExtension}`);
        const reportUrl = await reportRef.getDownloadURL();
        window.open(reportUrl);
      } catch (error) {
        this.$store.dispatch("snackbar", {
          message:
            "Error downloading report. The file might not be available yet or there was an error generating it.",
          color: "error",
        });
      }
    },
  },
};
</script>
<style scoped>
::v-deep .v-card__text.py-0.jobsite-card-text {
  padding: 10px 15px !important;
}
</style>
